import { demoTheme } from '../../theme';

/**
 * kanal_grup -> renk. TEK kaynak: ayni kanal ekranin HER yerinde ayni renkte
 * gorunmeli (Kanal blogundaki halka ile Sube blogundaki yigin ayni dili
 * konusur). `theme.ts` disinda YENI renk uretilmez.
 *
 * 'Bilinmeyen' (hesapsiz fis) veride bugun bos ama haritada karsiligi var.
 * Haritada olmayan bir grup gelirse `kanalRengi` textMuted'a duser - kirilmaz.
 */
export const GRUP_RENK: Record<string, string> = {
  Mağaza: demoTheme.primary,
  Pazaryeri: demoTheme.warning,
  Kurumsal: demoTheme.tierIleri,
  Online: demoTheme.positive,
  Bilinmeyen: demoTheme.textDisabled,
};

export function kanalRengi(kanalGrup: string): string {
  return GRUP_RENK[kanalGrup] ?? demoTheme.textMuted;
}

/**
 * Yigin siralamasi. Haritada olan gruplar bu sirayla, sonra haritada
 * OLMAYANLAR alfabetik gelir - beklenmedik bir kanal_grup sessizce
 * DUSURULMEZ, sadece sona alinir.
 */
const SIRA = Object.keys(GRUP_RENK);

export function kanalSirala(gruplar: string[]): string[] {
  const bilinen = SIRA.filter((g) => gruplar.includes(g));
  const bilinmeyen = gruplar.filter((g) => !SIRA.includes(g)).sort((a, b) => a.localeCompare(b, 'tr'));
  return [...bilinen, ...bilinmeyen];
}
